module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.0b76306.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Medium.otf
// module id = gViv
// module chunks = 0